import React, { useCallback, useState, useEffect } from 'react';

import {
  Button,
  Tooltip as SuperopsTooltip,
  Modal,
  ButtonGroup,
  Page,
  DisplayText,
  Checkbox,
  TextField
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import {
  getTranslatedText,
  Editor,
  RunbookNodeActivatorContent,
  TEXT_LENGTH,
  withErrorBoundary
} from '@nile/components';
import { injectIntl, FormattedMessage } from 'react-intl';
import { isEmpty, set } from 'lodash';

function AddNoteActionModal(props) {
  const { intl, isAutoAction } = props;

  const formData = props?.autoActionformData;
  const actionValueData = formData?.actionValueData;

  const editorRef = React.useRef(null);
  const [template, setTemplate] = useState({
    name: formData?.name || '',
    content: actionValueData?.note?.content || '',
    placeholdersUsed: ''
  });

  const nodeName = formData?.name || '';
  // || !isEmpty(template.content)
  //   ? template.content.match(/>(.*?)</)[1].substring(0, 10)
  //   : '';

  const [markAsPublic, setMarkAsPublic] = useState(
    actionValueData?.note?.privacyType === 'PUBLIC' || false
  );
  const [noteTitle, setNoteTitle] = useState(nodeName);
  const saveLoading = false;

  const parentActionId = formData?.parentActionId;
  const hasActionId = formData?.actionId;

  const [popoverActive, setPopoverActive] = useState(
    Boolean(
      (isAutoAction && !props?.autoActionformData) ||
        (!isAutoAction && !hasActionId)
    )
  );

  const showDeleteButton =
    (props.isAutoAction && props?.autoActionformData) ||
    (!props.isAutoAction && hasActionId);

  const togglePopoverActive = useCallback(() => {
    setPopoverActive((active) => !active);
  }, []);

  const activator = (
    <RunbookNodeActivatorContent
      nodeType="admin.runbooks.templateactions.addnote"
      nodeName={nodeName}
      iconName="NotesColoured"
      callBackFunction={togglePopoverActive}
    />
  );

  const updateTemplate = (obj) => {
    const updatedTemplate = { ...template, ...obj };
    setTemplate(updatedTemplate);
  };

  useEffect(() => {
    if (popoverActive) {
      setTemplate({
        name: formData?.name || '',
        content: actionValueData?.note?.content || '',
        placeholdersUsed: ''
      });
      setMarkAsPublic(actionValueData?.note?.privacyType === 'PUBLIC' || false);
      setNoteTitle(formData?.name || '');
    }
  }, [popoverActive]);

  const onSave = () => {
    const formDataTemp = {
      name: noteTitle || '',
      // id: props.id,
      actionType: 'SINGLE',
      actionProcessCategory: 'ASYNC',
      actionValueType: 'NOTE',
      actionValueData: {
        nodeId: props.id,
        note: {
          content: template.content,
          privacyType: markAsPublic ? 'PUBLIC' : 'PRIVATE'
        }
      }
    };
    if (hasActionId) {
      formDataTemp.actionId = hasActionId;
    }

    if (parentActionId) {
      formDataTemp.parentActionId = parentActionId;
    }

    if (props.isAutoAction) {
      props.autoActionSave(formDataTemp);
    } else {
      props.modifyNodeData(formDataTemp);
    }

    togglePopoverActive();
  };

  const handleNodeDelete = () => {
    setPopoverActive(false);

    if (props.isAutoAction) {
      props.handleAutoActionDelete(props.id);
    } else {
      props.data.handleNodeDelete(props.id, hasActionId);
    }
  };

  const handleNodeCancel = useCallback(() => {
    setTemplate({
      ...template,
      content: actionValueData?.note?.content || ''
    });
    setPopoverActive(false);
    if (!props?.autoActionformData) {
      props.handleAutoActionDelete(props.id);
    }
  }, [hasActionId, handleNodeDelete]);

  return (
    <Modal
      large
      activator={activator}
      open={popoverActive}
      onClose={togglePopoverActive}
      showCloseButton={false}
      noScroll
    >
      <Page
        title={getTranslatedText(
          intl,
          'admin.runbooks.templateactions.addnote'
        )}
        contentHeight="110px"
        fullWidth
        variant="secondary"
        primaryAction={
          <ButtonGroup spacing="loose">
            {showDeleteButton && (
              <Button plainSecondary onClick={handleNodeDelete}>
                <div className="danger">
                  <FormattedMessage id="project.details.delete" />
                </div>
              </Button>
            )}
            <Button plainSecondary onClick={handleNodeCancel}>
              <FormattedMessage id="common.cancel" />
            </Button>
            <Button
              primary
              icon={<SVGIcon name="Save" />}
              onClick={onSave}
              loading={saveLoading}
              disabled={
                noteTitle.trim() === '' || template.content.trim() === ''
              }
            >
              <FormattedMessage id="common.save" />
            </Button>
          </ButtonGroup>
        }
      >
        <div className="px-40">
          <div className="mb-20 flex justify-between">
            <TextField
              focused
              label={getTranslatedText(
                intl,
                'admin.runbooks.tasks.copy.name.pl'
              )}
              value={noteTitle}
              size="medium"
              // placeholder={getTranslatedText(
              //   intl,
              //   'admin.customForms.description.placeholder'
              // )}
              onChange={(val) => {
                setNoteTitle(val);
              }}
              maxLength={TEXT_LENGTH.size_5}
              noborder
            />
            <div className="flex justify-end ">
              <Checkbox
                checked={markAsPublic}
                label={'Mark as public'}
                onChange={(val) => {
                  setMarkAsPublic(val);
                }}
              />
            </div>
          </div>

          <Editor
            editorRef={editorRef}
            template={template}
            updateTemplate={updateTemplate}
            disableAttachment
            disableImageUpload
            placeholder={getTranslatedText(intl, 'attribute.optionalNotes')}
            module="RUNBOOK"
            // details={{
            //   operation: 'UPDATE'
            // }}
          />
        </div>
      </Page>
    </Modal>
  );
}

export default withErrorBoundary(injectIntl(AddNoteActionModal));
